export default __webpack_public_path__ + "static/media/Use-Cases-Section-Ideation.56eab328.jpg";